import {
    AutocompleteArrayInput,
    AutocompleteInput,
    Create,
    DateInput,
    ReferenceArrayInput,
    ReferenceInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileSearch, Users } from 'lucide-react';
import { required, useDataProvider } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { getNextRef } from '../documents/shared/documentReference';

const RFQRefGenerator = () => {
    const { setValue } = useFormContext();
    const dataProvider = useDataProvider();

    useEffect(() => {
        dataProvider.getList('rfqs', {
            pagination: { page: 1, perPage: 1000 },
            sort: { field: 'id', order: 'DESC' },
            filter: {}
        }).then(({ data }) => {
            const nextRef = getNextRef('rfq', data.map((r: any) => r.reference).filter(Boolean));
            setValue('reference', nextRef, { shouldDirty: true, shouldValidate: true });
        });
    }, [dataProvider, setValue]);

    return null;
};

export const RFQCreate = () => {
    return (
        <Create>
            <SimpleForm className="max-w-4xl mx-auto space-y-6">
                <RFQRefGenerator />
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <FileSearch className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">New Request for Quotation (RFQ)</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <TextInput source="reference" label="RFQ No." validate={required()} readOnly className="w-full font-mono opacity-70" helperText="Auto-generated sequence" />
                            
                            <ReferenceInput source="project_id" reference="projects">
                                <AutocompleteInput label="Project" validate={required()} className="w-full" />
                            </ReferenceInput>

                            <ReferenceInput source="bom_id" reference="boms">
                                <AutocompleteInput label="Source BoM" className="w-full" />
                            </ReferenceInput>

                            <DateInput source="due_date" label="Response Deadline" validate={required()} className="w-full" />
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <Users className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Vendor Invitation</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <ReferenceArrayInput source="vendor_ids" reference="vendors">
                            <AutocompleteArrayInput label="Target Vendors" placeholder="Search and select multiple vendors..." className="w-full" />
                        </ReferenceArrayInput>
                        <TextInput source="notes" label="Special Instructions to Vendors" multiline rows={3} className="w-full" />
                    </CardContent>
                </Card>

                <div className="hidden">
                    <TextInput source="status" defaultValue="draft" />
                </div>
            </SimpleForm>
        </Create>
    );
};
